export default "__VITE_ASSET__CalYbfOp__"